// The inline child lists a record shows, which the source puts on its detail
// views and `#59` lists per table.
//
// Every one of them is the collection endpoint with one equality filter -- the
// API's `_filters` exists for exactly this, which is why none of these needs an
// endpoint of its own.
//
// `Lines` is absent because D7 dropped `Barriers.Line` and the `Lines` table
// entirely: the column was set on one row of 1,824, and read-only and hidden in
// the source.

export interface RelatedList {
  /** The collection to list. */
  slug: string;
  /** The column on that collection holding this record's key. */
  column: string;
  label: string;
}

export const RELATED: Record<string, RelatedList[]> = {
  sites: [{ slug: 'barriers', column: 'site_id', label: 'Barriers' }],
  areas: [{ slug: 'barriers', column: 'area_id', label: 'Barriers' }],
  commodities: [{ slug: 'barriers', column: 'commodity_id', label: 'Barriers' }],
  departments: [{ slug: 'barriers', column: 'department_id', label: 'Barriers' }],
  products: [
    { slug: 'barriers', column: 'product_id', label: 'Barriers' },
    { slug: 'orders', column: 'product_id', label: 'Orders' },
    // NOT two-week production, which `#59` asks a product to show and the
    // schema cannot answer: `two_week_production` carries no product reference.
    // D15 dropped the source's `Two Week Production.Product Type` because all
    // 49 of its values pointed at `Products` keys that do not exist, and the
    // path it duplicated -- Job Number -> Orders -> Product -- resolves for 47
    // of them. So a product's two-week rows are reached through its orders,
    // and asking for them here would have been one equality filter on a column
    // the API refuses by name.
  ],
  orders: [
    { slug: 'barriers', column: 'order_id', label: 'Barriers' },
    { slug: 'two-week-production', column: 'order_id', label: 'Two Week Production' },
    { slug: 'daily-production', column: 'order_id', label: 'Daily Production' },
  ],
  barriers: [{ slug: 'barrier-owners', column: 'barrier_number', label: 'Owners' }],
  'root-causes': [{ slug: 'barriers', column: 'root_cause_id', label: 'Barriers' }],
  'buyer-statuses': [{ slug: 'barriers', column: 'buyer_status_id', label: 'Barriers' }],
  'warehouse-statuses': [{ slug: 'barriers', column: 'warehouse_status_id', label: 'Barriers' }],
  'app-users': [{ slug: 'barrier-owners', column: 'app_user_id', label: 'Barriers owned' }],
};
